module.exports = "https://store.zigzag.kr/resources/arm64/20260319-1138-60b8a0a8d9_store/_next/static/images/MedalVip-70c82bf8a20d9dddc5ddf2bb049a43eb.png";